import { render, staticRenderFns } from "./statutOf.vue?vue&type=template&id=0d38a688&scoped=true&lang=html&"
import script from "./statutOf.vue?vue&type=script&lang=js&"
export * from "./statutOf.vue?vue&type=script&lang=js&"
import style0 from "./statutOf.vue?vue&type=style&index=0&id=0d38a688&lang=css&scoped=true&"
import style1 from "./statutOf.vue?vue&type=style&index=1&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38a688",
  null
  
)

export default component.exports